import Cookies from "js-cookie";
import { baseApi } from "../baseApi";
import { resetAuth, setAuthUser } from "@/redux/auth/authSlice";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (user) => ({
        url: `/vendor/login`,
        method: "POST",
        body: user,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          const {
            data: { data },
          } = result;
          Cookies.set("token", data.token);
          dispatch(setAuthUser(data));
        } catch {
          // console.log(error)
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: `/auth/logout`,
        method: "POST",
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          Cookies.remove("token");
          window.location.href = "/";
          dispatch(resetAuth());
        } catch (error: unknown) {}
      },
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        url: `/vendor/password/reset-request`,
        method: "POST",
        body: email,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          dispatch(resetAuth());
        } catch (error: unknown) {}
      },
    }),
    resetPassword: builder.mutation({
      query: (resetPassword) => ({
        url: `/vendor/password/reset`,
        method: "POST",
        body: resetPassword,
      }),
    }),
    changePassword: builder.mutation({
      query: (passwordData) => ({
        url: `/vendor/password/change`,
        method: "POST",
        body: passwordData,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = authApi;
